import { css } from '@emotion/react'
import { Color, Spacing, Theme, Typography } from '@opallabs/gem'

export const container = css({
  alignItems: 'center',
  display: 'flex',
  flexFlow: 'row nowrap',
  inlineSize: '100%',
  justifyContent: 'space-between',
  ...Typography.T500,
})

export const details = css({
  alignItems: 'center',
  display: 'flex',
  flexFlow: 'row nowrap',
  columnGap: Spacing.S,
})

export const permissions = (theme: Theme) =>
  css({
    alignItems: 'center',
    color: Color[theme].Text.Gray,
    columnGap: Spacing.XS,
    display: 'flex',
    flexFlow: 'row nowrap',
    marginInlineEnd: 3,
  })

export const removeButton = css({
  blockSize: Spacing.M,
  inlineSize: Spacing.M,
})

export const inactiveWorkspaceMember = css({ opacity: 0.5 })

export const groupAvatar = css({
  backgroundColor: Color.dark.Surface.N400,

  span: {
    color: Color.dark['Text/Primary'],
  },
})

export const membersContainer = css({
  padding: `0 0 0 ${Spacing.S * 4}px`,
  margin: 0,
  rowGap: 8,
  display: 'flex',
  flexFlow: 'column nowrap',
  ...Typography.T500,
})

export const permissionSelect = (theme: Theme) =>
  css({
    '.single-select-value-input': {
      blockSize: Spacing.L,
      columnGap: Spacing.XS,
      padding: Spacing.XS,

      span: {
        color: Color[theme].Text.Gray,
      },
    },
  })
